import H from 'constants/httpMethod.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const beDeleteFee = actionEndpointBe('beDeleteFee', H.del, 'sales/salon/:salonId/fees/:id/', (options, extra) => ({
  ...options,
  inert: true,
  params: { id: fromAnyToTrimmed(extra?.id) },
}));
